import {
  SET_CONTACT,
  SET_CONTACT_COLUMNS,
  SET_HISTORY_FOR_CONTACT,
  UPDATE_PARAMS_HISTORY_CONTACT,
  CLEAR_CONTACT_HISTORY,
  SET_MESSAGES_FROM_HISTORY,
  SET_CONTACTS_FOUND_JOB,
  SELECT_CONTACT_CONTACTS_FOUND,
  CLEAR_CONTACTS_FOUND,
  RESET_CONTACT,
  UPDATE_CONTACT_FOUND,
  SET_CONTACT_FILTER,
  SET_CONTACT_FILTER_TYPE,
} from '../../mutation-types';
import ContactService from '../../../services/contact-service';
import { getMessagesFromJob } from '@/services/whatsapp-messages-service';
import {
  getDateLastContact,
  getMessageHistory,
  getMessageHistoryDb,
  deleteContact,
  getContactFiltersTemplate,
} from '@/services/contact-service';

const actions = {
  save({ dispatch }, { contact, contactColumns }) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!contact) throw new Error('Contact undefined');
        await ContactService.save(contact);

        dispatch('jobs/updateContactActiveJob', contact, { root: true });
        dispatch('jobs/updateContactColumnsActiveJob', contactColumns, {
          root: true,
        });
        dispatch('jobs/updateJobJobList', null, { root: true });

        resolve(true);
        dispatch(
          'showSnackbar',
          {
            type: 'success',

            text: 'Alterações salvas com sucesso',
          },
          { root: true },
        );
      } catch (err) {
        window.console.error(err);
        dispatch(
          'showSnackbar',
          {
            type: 'error',
            text: 'Ocorreu um erro ao salvar as alterações do contato',
          },
          { root: true },
        );
        reject();
      }
    });
  },

  add({ dispatch }, { contact, contactColumns }) {
    ContactService.save(contact)
      .then((res) => {
        dispatch('jobs/updateContactActiveJob', res.data, {
          root: true,
        });
        dispatch('jobs/updateContactColumnsActiveJob', contactColumns, {
          root: true,
        });
        dispatch('jobs/updateJobJobList', null, { root: true });

        dispatch(
          'showSnackbar',
          {
            type: 'success',

            text: 'addContactSuccess',
          },
          { root: true },
        );
      })
      .catch((err) => {
        window.console.error(err);
      });
  },

  async getById({ commit, dispatch }, event) {
    try {
      const [contact, contactColumns] = await Promise.all([
        ContactService.getByIdentifier(event.contactId),
        ContactService.getContactColumns(),
      ]);
      commit(SET_CONTACT_COLUMNS, contactColumns.data);
      commit(SET_CONTACT, contact);
    } catch (err) {
      dispatch(
        'showSnackbar',
        { text: 'Ocorreu um erro ao recuperar os dados do contato' },
        { root: true },
      );
    }
  },

  async getContactColumns({ commit, dispatch, state }) {
    try {
      if (!state.contactColumns.length) {
        const contactColumns = await ContactService.getContactColumns();
        commit(SET_CONTACT_COLUMNS, contactColumns.data);
      }
    } catch (err) {
      dispatch(
        'showSnackbar',
        { text: 'Ocorreu um erro ao recuperar os dados' },
        { root: true },
      );
    }
  },

  clearContactHistory({ commit }) {
    commit(CLEAR_CONTACT_HISTORY);
  },

  getContactHistory({ commit, dispatch }, parameters) {
    return new Promise((resolve, reject) => {
      ContactService.getContactHistory(parameters)
        .then((response) => {
          const history = response.data.data;

          commit(SET_HISTORY_FOR_CONTACT, history);
          dispatch(
            'setParamsQueryHistory',
            parameters.contact_id,
            response.data,
          );

          const hasMore =
            response.data.per_page * response.data.current_page <
            response.data.total;

          resolve(hasMore);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  setParamsQueryHistory({ commit }, responseHistory) {
    if (responseHistory) {
      delete responseHistory.data;
    }

    const commitParamsQuery = {
      newValue: responseHistory,
      property: 'paramsHistory',
    };

    commit(UPDATE_PARAMS_HISTORY_CONTACT, commitParamsQuery);
  },

  getMessagesFromJob({ commit }, { protocol, groupProtocol }) {
    getMessagesFromJob(protocol).then((response) => {
      const messages = response.data.data;
      commit(SET_MESSAGES_FROM_HISTORY, { protocol, groupProtocol, messages });
    });
  },

  lastContact({ dispatch }, { contactIdentifier, protocol }) {
    getDateLastContact(contactIdentifier)
      .then(({ lastContact }) => {
        if (!lastContact) return;

        dispatch(
          'jobs/addLastContact',
          { lastContact, protocol },
          { root: true },
        );
      })
      .catch(console.error);
  },

  getMessageHistory(
    {
      rootState: {
        attendance: { Attendance },
      },
    },
    {
      contactIdentifier,
      initialDate,
      page,
      formatMessages,
      channel,
      mustNot,
      org_unit_id,
      protocol_transfer,
      attendanceType,
      route,
    },
  ) {
    return new Promise((resolve, reject) => {
      getMessageHistory(
        contactIdentifier,
        initialDate,
        page,
        channel,
        mustNot,
        org_unit_id,
        protocol_transfer,
        attendanceType,
        route,
      ).then((responseMessages) => {
        try {
          const { agentId } = Attendance;
          const totalResults = responseMessages.data
            ? responseMessages.data.length
            : 0;

          if (!totalResults) return resolve({ totalResults, messages: [] });

          if (formatMessages) {
            return resolve({
              messages: formatMessages({
                messages: responseMessages.data,
                contactIdentifier,
                agentId,
              }),
              totalResults,
            });
          }

          resolve({ messages: responseMessages.data, totalResults });
        } catch (err) {
          reject(err);
        }
      });
    });
  },

  getMessageHistoryDb(
    {
      rootState: {
        attendance: { Attendance },
      },
    },
    { contactIdentifier, formatMessages, protocol },
  ) {
    return new Promise((resolve, reject) => {
      getMessageHistoryDb(contactIdentifier, protocol).then(
        (responseMessages) => {
          try {
            const { agentId } = Attendance;
            const totalResults = responseMessages.data
              ? responseMessages.data.length
              : 0;

            if (!totalResults) return resolve({ totalResults, messages: [] });

            if (formatMessages) {
              return resolve({
                messages: formatMessages({
                  messages: responseMessages.data,
                  contactIdentifier,
                  agentId,
                }),
                totalResults,
              });
            }

            resolve({ messages: responseMessages.data, totalResults });
          } catch (err) {
            reject(err);
          }
        },
      );
    });
  },

  setContactsFound({ commit }, { protocol, contacts }) {
    commit(SET_CONTACTS_FOUND_JOB, { protocol, contacts });
  },

  setSelectContactContactsFound({ commit }, { contactId, protocol }) {
    commit(SELECT_CONTACT_CONTACTS_FOUND, { contactId, protocol });
  },

  clearContactsFound({ commit }, protocol) {
    commit(CLEAR_CONTACTS_FOUND, protocol);
  },

  reset({ commit }) {
    commit(RESET_CONTACT);
  },
  updateContactsFoundByProtocol({ commit }, jobInfo) {
    commit(UPDATE_CONTACT_FOUND, jobInfo);
  },
  async deleteContact({ dispatch }, { identifier, agentId }) {
    await deleteContact(identifier, 'AGENT-' + agentId)
      .then((response) => {
        dispatch(
          'showSnackbar',
          { text: 'Contato excluído com sucesso' },
          { root: true },
        );
      })
      .catch((err) => {
        dispatch(
          'showSnackbar',
          { text: 'Contato não pode ser excluído', type: 'error' },
          { root: true },
        );
      });
  },
  async getContactFiltersTemplate({ rootState }) {
    const orgUnitId = rootState.attendance.Attendance.org_unit_id;
    return await getContactFiltersTemplate(orgUnitId).catch((err) => {
      window.console.error(err);
    });
  },
  saveContactFilterSelected({ commit }, contactFilterId) {
    commit(SET_CONTACT_FILTER, contactFilterId);
  },
  saveContactFilterTypeSelected({ commit }, type) {
    commit(SET_CONTACT_FILTER_TYPE, type);
  },
};
export default actions;
